export default "__VITE_ASSET__4rs8LYZ2__"